// CANONICAL COPY (GH #7115). src/constants/obligations/obl-subprocessor-registry.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-subprocessor-registry',
  title: 'Maintain sub-processor registry',
  description:
    'Confirm that a current register of approved sub-processors is maintained with at minimum name, CVR / company registration number, address and description of the processing carried out (GDPR Art. 28(2); FSR ISAE 3000 Kontrolmål F.1, F.5). The register shall be published or made available to controllers on request, updated promptly when sub-processors are engaged or removed, and reviewed at least annually. Review the sub-processor register, the procedure for engaging sub-processors, and the annual review record.',
  category: 'vendors',
  scfIds: ['SCF-VDR-001'],
  cadence: { frequency: '1y', anchor: 'domain' },
  // GH #6698, founder decision B. Was `strategy: 'any'`, under which a
  // published, in-SLA procedure fulfilled this obligation ON ITS OWN — and a
  // fulfilled obligation then rendered every other criterion as "Fulfilled",
  // so a tenant with an unclassified vendor register was shown a green tick
  // against the sub-processor register itself.
  //
  // `manual` requires ALL criteria plus the human attestation, and yields
  // `partially-satisfied` rather than `unmet` for a tenant that has the
  // procedure but not the record — so nobody is stranded, and nobody is told
  // the record exists. This is the product's own doctrine applied where it
  // already belonged: "a published/current document is machine-checkable
  // evidence that a policy or procedure exists; it is never treated as proof
  // the underlying activity actually occurred" (`evaluateManualObligation`).
  // GDPR Art. 28(2) requires a register, not a procedure describing one.
  strategy: 'manual',
  fulfilmentCriteria: [
    {
      type: 'subprocessor-registry-maintained',
      description: 'Sub-processor registry in the Vendors module is complete',
    },
    { type: 'document-published', description: 'Sub-processor engagement procedure is published' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
    {
      type: 'manual-attestation',
      description:
        'Confirm the sub-processor register is current — that it lists every engaged sub-processor with name, registration number, address and processing description, and that the annual review has been done',
    },
  ],
  domainActions: [
    { type: 'deep-link', target: 'vendors', label: 'Review Vendors' },
    { type: 'approve-document', label: 'Approve Document' },
  ],
};
